import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../authentication.service';

@Component({
    selector: 'app-unregistered',
    templateUrl: './unregistered.component.html',
    styleUrls: ['./unregistered.component.scss']
})
export class UnregisteredComponent {

    constructor(private authService: AuthenticationService,
                private router: Router) {
    }

    logout() {
        this.authService.logout();
    }
}
